import { graphql } from '@repo/api-kit/graphql';

export const SEARCH_SUPPLIER_INVOICES = graphql(`
  query searchSupplierInvoices(
    $filters: SupplierInvoicesFilters
    $pagination: SupplierInvoicesPagination
    $sort: Sort
  ) {
    searchSupplierInvoices(input: { filters: $filters, sort: $sort, pagination: $pagination }) {
      supplierInvoices {
        id
        issuerName
        invoiceNumber
        status
        source
        attachmentCategory
        meta {
          integrationType
          integrationName
          connector
          emailedBy
          resolvedBy {
            id
            person {
              id
              fullName
            }
          }
        }
        supplierSnapshot {
          id
          name
        }
        createdAt
        totalAmount {
          value
          currency
        }
      }
      meta {
        currentPage
        nextPage
        prevPage
        totalPages
        totalCount
        perPage
      }
    }
  }
`);

export const SEARCH_SINGLE_SUPPLIER_INVOICE = graphql(`
  query searchSingleSupplierInvoice($id: String!) {
    searchSingleSupplierInvoice(input: { id: $id }) {
      supplierInvoice {
        id
        attachmentId
        issuerName
        invoiceNumber
        fileName
        status
        source
        attachmentCategory
        markedAsRead
        supplierSnapshot {
          id
          name
        }
        meta {
          integrationType
          integrationName
          connector
          emailedBy
        }
        createdAt
        totalAmount {
          value
          currency
        }
        suggestedTransactions {
          id
          counterpartyName
          emittedAt
          operationMethod
          amount {
            value
            currency
          }
        }
      }
    }
  }
`);

export const COUNT_SUPPLIER_INVOICES = graphql(`
  query countSupplierInvoices($markedAsRead: [Boolean]) {
    searchSupplierInvoices(
      input: { filters: { markedAsRead: $markedAsRead }, pagination: { perPage: 1, page: 1 } }
    ) {
      supplierInvoices {
        id
      }
      meta {
        totalCount
      }
    }
  }
`);

export const GET_SUGGESTED_INVOICES_FOR_BILL_PAY = graphql(`
  query getSuggestedInvoicesForBillPay(
    $filters: SupplierInvoicesFilters
    $pagination: SupplierInvoicesPagination
    $sort: Sort
  ) {
    searchSupplierInvoices(input: { filters: $filters, sort: $sort, pagination: $pagination }) {
      supplierInvoices {
        id
        issuerName
        dueDate
        issueDate
        payableAmount {
          currency
          value
        }
        source
        isEinvoice
        einvoiceFormat
        supplierSnapshot {
          name
        }
        meta {
          integrationName
          integrationType
          connector
          emailedBy
        }
        displayAttachment {
          thumbnail {
            fileUrl
          }
        }
      }
    }
  }
`);
